<template>
  <div>
    <v-card class="mx-auto mt-12">
      <h2>Transaction Info</h2>
      <v-card-text>
        <v-row>
          <v-col cols="3">
            <key-value title="Id">
              <span class="small" v-text="transaction.transaction_id"></span>
            </key-value>
            <key-value title="Amount">
              <h3>{{ "€" + transaction.amount_in_euros }}</h3>
            </key-value>
          </v-col>
          <v-col cols="3">
            <key-value title="Transaction Type">
              <h3>{{ transaction.type }}</h3>
            </key-value>
          </v-col>
          <v-col cols="3">
            <key-value
              title="Sender Confirmation Status"
              :value="transaction.destination_user.country"
            >
              <h3 class="success--text" v-if="transaction.sender_confirmed_execution == true">
                SUCCESS
              </h3>
              <h3 class="warning--text" v-else>PENDING</h3>
            </key-value>
            <key-value title="Escrow Manager Confirmation Status">
              <h3 class="success--text" v-if="transaction.manager_confirmed_execution == true">
                SUCCESS
              </h3>
              <h3 class="warning--text" v-else>PENDING</h3>
            </key-value>
            <key-value
              title="Receiver Confirmation Status"
              :value="transaction.destination_user.birth_city"
            >
              <h3 class="success--text" v-if="transaction.receiver_confirmed_execution == true">
                SUCCESS
              </h3>
              <h3 class="warning--text" v-else>PENDING</h3>
            </key-value>
          </v-col>

          <v-col cols="3">
            <key-value title="Transfer Status">
              <!-- <h3 class="success--text" v-if="transaction.status == 'executed'">
                <v-icon color="success" size="25">mdi-progress-check</v-icon>
                COMPLETED
              </h3> -->
              <h3 class="warning--text">{{ transaction.status }}</h3>
            </key-value>
          </v-col>
        </v-row>
        <v-row>
          <v-row align="center" justify="space-around">
            <v-col>
              <v-btn
                color="primary"
                :disabled="
                  transaction.status == 'escrowing' ||
                  transaction.status == 'releasing' ||
                  transaction.status == 'refunding' ||
                  transaction.status == 'payment_pending' ||
                  transaction.status == 'release_submitted' ||
                  transaction.status == 'revoking_release_confirmation' ||
                  transaction.status == 'revoking_refund_confirmation' ||
                  transaction.status == 'refund_submitted' ||
                  transaction.status == 'executed' ||
                  transaction.status == 'warning' ||
                  transaction.status == 'refunded'
                "
                @click="confirmTransaction"
                class="mx-2"
              >
                <span
                  v-if="
                    transaction.status == 'payment_started' || transaction.status == 'escrowing'
                  "
                  >Escrowing</span
                >
                <span v-else>Confirm Release</span>
              </v-btn>
              <v-btn
                class="mx-2"
                :disabled="
                  transaction.status == 'escrowing' ||
                  transaction.status == 'releasing' ||
                  transaction.status == 'refunding' ||
                  transaction.status == 'payment_pending' ||
                  transaction.status == 'revoking_release_confirmation' ||
                  transaction.status == 'revoking_refund_confirmation' ||
                  transaction.status == 'funds_escrowed' ||
                  transaction.status == 'refund_submitted' ||
                  transaction.status == 'executed' ||
                  transaction.status == 'refunded'
                "
                @click="revokeTransaction"
                color="primary"
              >
                Revoke Release
              </v-btn>
              <v-btn
                :disabled="
                  transaction.status == 'refunded' ||
                  transaction.status == 'escrowing' ||
                  transaction.status == 'releasing' ||
                  transaction.status == 'refunding' ||
                  transaction.status == 'payment_pending' ||
                  transaction.status == 'revoking_release_confirmation' ||
                  transaction.status == 'revoking_refund_confirmation' ||
                  transaction.status == 'release_submitted' ||
                  transaction.status == 'refund_submitted' ||
                  transaction.status == 'executed' ||
                  transaction.status == 'warning' ||
                  transaction.status == 'funds_escrowed'
                "
                @click="approveRefund"
                color="primary"
              >
                confirm refund
              </v-btn>
              <v-btn
                :disabled="
                  transaction.status == 'funded' ||
                  transaction.status == 'escrowing' ||
                  transaction.status == 'warning' ||
                  transaction.status == 'refunding' ||
                  transaction.status == 'payment_pending' ||
                  transaction.status == 'releasing' ||
                  transaction.status == 'executed' ||
                  transaction.status == 'revoking_release_confirmation' ||
                  transaction.status == 'revoking_refund_confirmation' ||
                  transaction.status == 'release_submitted' ||
                  transaction.status == 'funds_escrowed'
                "
                @click="revokeRefund"
                color="danger"
                class="ml-2"
              >
                Revoke refund
              </v-btn>
            </v-col>
          </v-row>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card class="mx-auto mt-12">
      <h2>Recipient Info</h2>
      <v-card-text>
        <v-row>
          <v-col cols="3">
            <key-value title="Id">
              <span class="small" v-text="transaction.destination_user.id"></span>
            </key-value>
            <key-value title="First Name" :value="transaction.destination_user.first_name" />
            <key-value title="Last Name" :value="transaction.destination_user.last_name" />
            <key-value
              title="Date of birth"
              :value="transaction.destination_user.birth_date"
              type="none"
            />
          </v-col>
          <v-col cols="3">
            <key-value title="Country" :value="transaction.destination_user.country" />
            <key-value
              title="Phone Number"
              :value="transaction.destination_user.full_phone_number"
            />
            <key-value title="Birth Place" :value="transaction.destination_user.birth_city" />
            <key-value title="Birth Country" :value="transaction.destination_user.birth_country" />
          </v-col>
          <v-col cols="3">
            <key-value title="Email" :value="transaction.destination_user.email" />
            <key-value
              title="Verification Result"
              :value="transaction.destination_user.verification_result"
            />
            <!-- <key-value title="Account Balance">
              <span>€{{ transaction.destination_client.euro_balance }}</span>
            </key-value> -->
          </v-col>
          <v-col cols="3">
            <key-value title="Activity status">
              <v-icon color="success" size="25" v-if="transaction.destination_user.is_active"
                >mdi-progress-check</v-icon
              >
            </key-value>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card class="mx-auto my-12">
      <h2 class="mx-6">Sender Info</h2>
      <v-card-text>
        <v-row>
          <v-col cols="3">
            <key-value title="Id">
              <span class="small" v-text="transaction.transaction_id"></span>
            </key-value>
            <key-value title="First Name" :value="transaction.source_user.first_name" />
            <key-value title="Last Name" :value="transaction.source_user.last_name" />
            <key-value
              title="Date of birth"
              :value="transaction.source_user.birth_date"
              type="none"
            />
          </v-col>
          <v-col cols="3">
            <key-value title="Country" :value="transaction.source_user.country" />
            <key-value title="Phone Number" :value="transaction.source_user.full_phone_number" />
            <key-value title="Birth Place" :value="transaction.source_user.birth_city" />
            <key-value title="Birth Country" :value="transaction.source_user.birth_country" />
          </v-col>
          <v-col cols="3">
            <key-value title="Email" :value="transaction.source_user.email" />
            <key-value
              title="Verification Result"
              :value="transaction.source_user.verification_result"
            />
            <!-- <key-value title="Account Balance">
              <span>€{{ transaction.source_client.euro_balance }}</span>
            </key-value> -->
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
export default {
  props: {
    payment_id: {
      required: true,
      type: String,
    },
  },
  data: () => ({
    transaction: null,
  }),
  mounted() {
    this.fetchData();
  },
  computed: {
    isConfirmed() {
      return (
        this.transaction.status == "release_submitted" ||
        this.transaction.status == "executed" ||
        this.transaction.status == "refunded"
      );
    },
  },
  methods: {
    fetchData() {
      this.$http
        .get(`/api/v1/operations/${this.payment_id}`)
        .then((transaction) => (this.transaction = transaction));
    },
    confirmTransaction() {
      this.$http
        .post(`/api/v1/escrowTransactions/${this.transaction.transaction_id}/confirmExecution`)
        .then((transaction) => {
          window.Notify.success("Escrow transaction confirmation request submitted successfully");
          this.fetchData();
          this.$router.push({ name: "escrowTransfers.show", params: transaction.transaction_id });
        })
        .catch((error) => window.Notify.error(error.message));
    },
    revokeTransaction() {
      this.$http
        .post(
          `/api/v1/escrowTransactions/${this.transaction.transaction_id}/revokeExecutionConfirmation`,
        )
        .then((transaction) => {
          this.fetchData();
          window.Notify.success("Escrow transaction execution request submitted successfully");
          this.$router.push({ name: "escrowTransfers.show", params: transaction.transaction_id });
        })
        .catch((error) => window.Notify.error(error.message));
    },
    approveRefund() {
      this.$http
        .post(`/api/v1/escrowTransactions/${this.transaction.transaction_id}/confirmRefund`)
        .then((transaction) => {
          this.fetchData();
          window.Notify.success("Escrow transaction execution request submitted successfully");
          this.$router.push({ name: "escrowTransfers.show", params: transaction.transaction_id });
        })
        .catch((error) => window.Notify.error(error));
    },
    revokeRefund() {
      this.$http
        .post(
          `/api/v1/escrowTransactions/${this.transaction.transaction_id}/revokeRefundConfirmation`,
        )
        .then((transaction) => {
          this.fetchData();
          window.Notify.success("Escrow transaction Refund request submitted successfully");
          this.$router.push({ name: "escrowTransfers.show", params: transaction.transaction_id });
        })
        .catch((error) => window.Notify.error(error));
    },
  },
};
</script>
